import CompanyIcon from '~/components/icons/CompanyIcon';
import { getDevicePixelRatio } from '~/lib/helpers';

import styles from './CompanyLogo.style';

const ENDPOINT = 'https://logo.clearbit.com';

const CompanyImg = ({ className, src, onError }) => (
  <img alt="Company Logo" className={className} src={src} onError={onError} />
);

CompanyImg.propTypes = {
  className: PropTypes.string.isRequired,
  onError: PropTypes.func.isRequired,
  src: PropTypes.string.isRequired,
};

class CompanyLogo extends React.Component {
  state = {
    error: false,
  };

  UNSAFE_componentWillReceiveProps = (newProps) => {
    if (newProps.domain !== this.props.domain) {
      this.setState({ error: false });
    }
  };

  onError = (error) => {
    this.setState({ error });
  };

  render() {
    const { src, domain, classes, className, size } = this.props;
    const { error } = this.state;

    const ratio = Math.round(getDevicePixelRatio());

    let srcSize = size;
    if (ratio > 1 && typeof srcSize === 'number') {
      srcSize *= ratio;
    }

    const containerClass = classnames(classes.root, className);
    const nullSrc = src === null;
    const logoSrc = (src || ENDPOINT + '/' + domain) + `?s=${srcSize}`;

    return (
      <div className={containerClass} style={{ width: size, height: size }}>
        {error || nullSrc ? (
          <CompanyIcon />
        ) : (
          <CompanyImg
            src={logoSrc}
            className={classes.image}
            onError={this.onError}
          />
        )}
      </div>
    );
  }
}

CompanyLogo.defaultProps = {
  size: 24,
  src: undefined,
};

CompanyLogo.propTypes = {
  domain: PropTypes.string,
  size: PropTypes.number,
  src: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(CompanyLogo);
